module.exports = __webpack_public_path__ + "img/20200507_135539.dff6dc61.jpg";